import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { DuplicatePostModal } from "@circle-react/components/Spaces/ImageSpace/DuplicatePostModal";
import { useDuplicatePost } from "@circle-react/components/Spaces/ImageSpace/DuplicatePostModal/hooks/useDuplicatePost";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import { isFunction } from "lodash";

import type { DuplicateImagePostModalProps } from "./types";

export const DuplicateImagePostModalUIKitComponent = ({
  post,
  onSuccess,
}: DuplicateImagePostModalProps) => {
  const modal = useModal();
  const { isLoading: isLoadingSpaces, helpers } = useSpacesContext();

  const { duplicate, isDuplicating } = useDuplicatePost({
    post,
    onSuccess: duplicatedPost => {
      isFunction(onSuccess) && onSuccess(duplicatedPost);
      void modal.remove();
    },
  });

  return (
    <DuplicatePostModal
      post={post}
      spaces={helpers.imageSpacesWithPostCreationAllowed()}
      isOpen={modal.visible}
      isLoading={isLoadingSpaces}
      isSubmitting={isDuplicating}
      onSubmit={duplicate}
      onClose={modal.remove}
    />
  );
};
